import { WizardCard, WizardSection } from '../../ui/wizard-layout';
import KundeUndProfil from '../../person/KundeUndProfil';
import type { KundeUndProfilWert } from '../../../lib/api/stammdaten';

type StepParticipantSelectionProps = Readonly<{
  wert: KundeUndProfilWert;
  onChange: (wert: KundeUndProfilWert) => void;
  standortId?: number | null;
  /** Bei „Anfrage umwandeln" bringt die Anfrage Name und Kontakt schon mit. */
  ausAnfrage?: { firstName?: string; lastName?: string; email?: string; phone?: string };
  pruefen?: boolean;
}>;

/**
 * Schritt „Teilnehmer" — Kunde und Schülerprofil getrennt (T-0007).
 *
 * Vorher stand hier zweierlei nebeneinander: bei „Anfrage umwandeln" ein
 * Formular, das Anrede, Geburtsdatum und Anschrift in *einem* Block abfragte
 * (wessen, blieb offen), und beim Anlegen von Hand die Frage „Warst du schonmal
 * bei uns?" mit einer Suche über alle Schülerprofile — oder einem Formular mit
 * genau drei Feldern: Vorname, Nachname, E-Mail.
 *
 * Beide Wege nehmen jetzt dieselbe Auswahl.
 */
const StepParticipantSelection = ({
  wert,
  onChange,
  standortId,
  ausAnfrage,
  pruefen = false,
}: StepParticipantSelectionProps) => (
  <WizardCard className="my-3">
    <WizardSection title="Teilnehmer">
      <KundeUndProfil
        wert={wert}
        onChange={onChange}
        standortId={standortId}
        ausAnfrage={ausAnfrage}
        pruefen={pruefen}
      />
    </WizardSection>
  </WizardCard>
);

export default StepParticipantSelection;
